import { render, staticRenderFns } from "./cadformulas.vue?vue&type=template&id=5393a800&"
import script from "./cadformulas.vue?vue&type=script&lang=js&"
export * from "./cadformulas.vue?vue&type=script&lang=js&"
import style0 from "./cadformulas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports